<template>
  <div>
    <hr>
    <div class="input-group input-group-sm">
      <input class="form-control form-control-sm" v-model="commentText" @keydown.13="postWithKey">
      <div class="input-group-append">
        <span class="input-group-text bg-white comment" @click="doComment">Enviar</span>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    postID: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      user: "getCurrentUser"
    })
  },
  data () {
    return {
      commentText: undefined
    }
  },
  methods: {
    postWithKey: function () {
      this.doComment();
    },
    doComment: function () {
      if ( !this.commentText ) return

      Axios.post('/comment', {
        post: this.postID,
        user: this.user.id,
        comment: this.commentText
      })
        .then( () => {
          this.commentText = undefined
          this.$emit('reloadComments', ['nopg'])
        })
        .catch( err => {
          console.error( err )
        })
    }
  }
}
</script>

<style>

</style>
